import styled from "styled-components";
import {XCloseButtonBox} from "../../../../../../basic-ui-components/x-close-button/x-close-button.box";
import {
    GAME_MOBILE_BUTTON_HEIGHT,
    GAME_MOBILE_BUTTON_WIDTH, GAME_PC_BUTTON_HEIGHT, GAME_PC_BUTTON_WIDTH
} from "../../../../game-css-constants";

export const GameHeaderBarCloseButtonBox = styled(XCloseButtonBox)`
  width: ${GAME_PC_BUTTON_WIDTH};
  height: ${GAME_PC_BUTTON_HEIGHT};

  @media ${props => props.theme.mediaQuery.sAndBelow} {
    width: ${GAME_MOBILE_BUTTON_WIDTH};
    height: ${GAME_MOBILE_BUTTON_HEIGHT};
  }
`

